export const POSTHOG_API_KEY = process.env.NEXT_PUBLIC_POSTHOG_API_KEY;
export const POSTHOG_API_HOST = process.env.NEXT_PUBLIC_POSTHOG_API_HOST;
export const POSTHOG_PERSONAL_API_KEY = process.env.POSTHOG_PERSONAL_API_KEY;
export const POSTHOG_PERSONAL_API_KEY_FULL_ACCESS =
  process.env.POSTHOG_PERSONAL_API_KEY_FULL_ACCESS;
export const POSTHOG_PROJECT_ID = process.env.POSTHOG_PROJECT_ID;

type Variant = 'control' | 'test';

type Experiment = {
  id: string;
  path: string;
  slug: string;
  variant?: {
    slug?: {
      [key in Variant]: string;
    };
  };
  metadata?: {
    state?: string;
    test: {
      [key: string]: string | number;
    }[];
  };
};

type VariantPath = {
  params: {
    slug: string[];
    locale: string;
  };
};

export const priceExperiments = [
  {
    stateCode: 'PA',
    featureFlag: 'website-price-change-PA',
    priceCurrent: 99,
    priceNew: 79,
    priceRenew: 79,
    statePage: {
      heroSection: '',
      discountCode: 'PA79',
      discountLabel: 'Claim $20 Off',
    },
    homePageCta: {
      key: 'price-change-homepage-PA',
      title:
        '<span>Get approved in Pennsylvania and<br /><span class="text-2xl">SAVE <span class="opacity-50 mr-2">$20</span></span></span>',
      description: 'Offer ends soon',
      label: 'Claim $20 Off',
      url: 'https://www.leafwell.com/medical-card/pennsylvania?discount_code=PA79',
    },
    genericCta: {
      key: 'price-change-banner-PA',
      title: 'SAVE $20 on your Pennsylvania medical card',
      description: 'Offer ends soon - get approved online in minutes',
      label: 'Claim $20 Off',
      url: 'https://www.leafwell.com/medical-card/pennsylvania?discount_code=PA79',
    },
  },
  {
    stateCode: 'MA',
    featureFlag: 'website-price-change-MA',
    priceCurrent: 99,
    priceNew: 79,
    priceRenew: 79,
    statePage: {
      heroSection: '',
      discountCode: 'MA79',
      discountLabel: 'Claim $20 Off',
    },
    homePageCta: {
      key: 'price-change-homepage-MA',
      title:
        '<span>Get approved in Massachusetts and<br /><span class="text-2xl">SAVE <span class="opacity-50 mr-2">$20</span></span></span>',
      description: 'Offer ends soon',
      label: 'Claim $20 Off',
      url: 'https://www.leafwell.com/medical-card/massachusetts?discount_code=MA79',
    },
    genericCta: {
      key: 'price-change-banner-MA',
      title: 'SAVE $20 on your Massachusetts medical card',
      description: 'Offer ends soon - get approved online in minutes',
      label: 'Claim $20 Off',
      url: 'https://www.leafwell.com/medical-card/massachusetts?discount_code=MA79',
    },
  },
  {
    stateCode: 'NY',
    featureFlag: 'website-price-change-NY',
    priceCurrent: 99,
    priceNew: 79,
    priceRenew: 79,
    statePage: {
      heroSection: '',
      discountCode: 'NY79',
      discountLabel: 'Claim $20 Off',
    },
    homePageCta: {
      key: 'price-change-homepage-NY',
      title:
        '<span>Get approved in New York and<br /><span class="text-2xl">SAVE <span class="opacity-50 mr-2">$20</span></span></span>',
      description: 'Offer ends soon',
      label: 'Claim $20 Off',
      url: 'https://www.leafwell.com/medical-card/new-york?discount_code=NY79',
    },
    genericCta: {
      key: 'price-change-banner-NY',
      title: 'SAVE $20 on your New York medical card',
      description: 'Offer ends soon - get approved online in minutes',
      label: 'Claim $20 Off',
      url: 'https://www.leafwell.com/medical-card/new-york?discount_code=NY79',
    },
  },
  {
    stateCode: 'LA',
    featureFlag: 'website-price-change-LA',
    priceCurrent: 79,
    priceNew: 69,
    priceRenew: 69,
    statePage: {
      heroSection: '',
      discountCode: 'LA69',
      discountLabel: 'Claim $10 Off',
    },
    homePageCta: {
      key: 'price-change-homepage-LA',
      title:
        '<span>Get approved in Louisiana and<br /><span class="text-2xl">SAVE <span class="opacity-50 mr-2">$10</span></span></span>',
      description: 'Offer ends soon',
      label: 'Claim $10 Off',
      url: 'https://www.leafwell.com/medical-card/louisiana?discount_code=LA69',
    },
    genericCta: {
      key: 'price-change-banner-LA',
      title: 'SAVE $10 on your Louisiana medical card',
      description: 'Offer ends soon - get approved online in minutes',
      label: 'Claim $10 Off',
      url: 'https://www.leafwell.com/medical-card/louisiana?discount_code=LA69',
    },
  },
  {
    stateCode: 'NJ',
    featureFlag: 'website-price-change-NJ',
    priceCurrent: 99,
    priceNew: 79,
    priceRenew: 79,
    statePage: {
      heroSection: '',
      discountCode: 'NJ79',
      discountLabel: 'Claim $20 Off',
    },
    homePageCta: {
      key: 'price-change-homepage-NJ',
      title:
        '<span>Get approved in New Jersey and<br /><span class="text-2xl">SAVE <span class="opacity-50 mr-2">$20</span></span></span>',
      description: 'Offer ends soon',
      label: 'Claim $20 Off',
      url: 'https://www.leafwell.com/medical-card/new-jersey?discount_code=NJ79',
    },
    genericCta: {
      key: 'price-change-banner-NJ',
      title: 'SAVE $20 on your New Jersey medical card',
      description: 'Offer ends soon - get approved online in minutes',
      label: 'Claim $20 Off',
      url: 'https://www.leafwell.com/medical-card/new-jersey?discount_code=NJ79',
    },
  },
  {
    stateCode: 'OH',
    featureFlag: 'website-price-change-OH',
    priceCurrent: 99,
    priceNew: 79,
    priceRenew: 79,
    statePage: {
      heroSection: '',
      discountCode: 'OH79',
      discountLabel: 'Claim $20 Off',
    },
    homePageCta: {
      key: 'price-change-homepage-OH',
      title:
        '<span>Get approved in Ohio and<br /><span class="text-2xl">SAVE <span class="opacity-50 mr-2">$20</span></span></span>',
      description: 'Offer ends soon',
      label: 'Claim $20 Off',
      url: 'https://www.leafwell.com/medical-card/ohio?discount_code=OH79',
    },
    genericCta: {
      key: 'price-change-banner-OH',
      title: 'SAVE $20 on your Ohio medical card',
      description: 'Offer ends soon - get approved online in minutes',
      label: 'Claim $20 Off',
      url: 'https://www.leafwell.com/medical-card/ohio?discount_code=OH79',
    },
  },
  {
    stateCode: 'WV',
    featureFlag: 'website-price-change-WV',
    priceCurrent: 99,
    priceNew: 79,
    priceRenew: 79,
    statePage: {
      heroSection: '',
      discountCode: 'WV79',
      discountLabel: 'Save $20 Now',
    },
    homePageCta: {
      key: 'price-change-homepage-WV',
      title:
        '<span>Get approved in West Virginia and<br /><span class="text-2xl">SAVE <span class="opacity-50 mr-2">$20</span></span></span>',
      description: 'Offer ends soon',
      label: 'Claim $20 Off',
      url: 'https://www.leafwell.com/medical-card/west-virginia?discount_code=WV79',
    },
    genericCta: {
      key: 'price-change-banner-WV',
      title: 'SAVE $20 on your West Virginia medical card',
      description: 'Offer ends soon - get approved online in minutes',
      label: 'Claim $20 Off',
      url: 'https://www.leafwell.com/medical-card/west-virginia?discount_code=WV79',
    },
  },
  {
    stateCode: 'VA',
    featureFlag: 'website-price-change-VA',
    priceCurrent: 99,
    priceNew: 79,
    priceRenew: 79,
    statePage: {
      heroSection: '',
      discountCode: 'VA79',
      discountLabel: 'Save $20 Now',
    },
    homePageCta: {
      key: 'price-change-homepage-VA',
      title:
        '<span>Get approved in Virginia and<br /><span class="text-2xl">SAVE <span class="opacity-50 mr-2">$20</span></span></span>',
      description: 'Offer ends soon',
      label: 'Claim $20 Off',
      url: 'https://www.leafwell.com/medical-card/virginia?discount_code=VA79',
    },
    genericCta: {
      key: 'price-change-banner-VA',
      title: 'SAVE $20 on your Virginia medical card',
      description: 'Offer ends soon - get approved online in minutes',
      label: 'Claim $20 Off',
      url: 'https://www.leafwell.com/medical-card/virginia?discount_code=VA79',
    },
  },
];

export const experiments: Experiment[] = [
  {
    id: 'new-mc-page-pennsylvania',
    path: '/medical-card/pennsylvania',
    slug: 'pennsylvania',
    variant: {
      slug: {
        test: '/medical-card/pennsylvania',
        control: '/medical-card/pennsylvania-old',
      },
    },
  },
  {
    id: 'new-mc-page-ohio',
    path: '/medical-card/ohio',
    slug: 'ohio',
    variant: {
      slug: {
        test: '/medical-card/ohio',
        control: '/medical-card/ohio-old',
      },
    },
  },
  {
    id: 'new-mc-page-massachusetts',
    path: '/medical-card/massachusetts',
    slug: 'massachusetts',
    variant: {
      slug: {
        test: '/medical-card/massachusetts',
        control: '/medical-card/massachusetts-old',
      },
    },
  },
  {
    id: 'new-mc-page-louisiana',
    path: '/medical-card/louisiana',
    slug: 'louisiana',
    variant: {
      slug: {
        test: '/medical-card/louisiana',
        control: '/medical-card/louisiana-old',
      },
    },
  },
  {
    id: 'new-mc-page-virginia',
    path: '/medical-card/virginia',
    slug: 'virginia',
    variant: {
      slug: {
        test: '/medical-card/virginia',
        control: '/medical-card/virginia-old',
      },
    },
  },
];

export function getExperimentByKey(key: string) {
  return experiments.find(experiment => experiment[key] === key);
}

export function getExperimentSlugByVariant(params: string[], variant: Variant) {
  const slug = `/${params.join('/')}`;
  const experiment = experiments.find(experiment => {
    return experiment.path === slug;
  });

  if (!experiment?.variant?.slug[variant]) {
    throw new Error(
      `Error in 'getStaticProps': Experiment not found for ${slug}`,
    );
  }

  return experiment.variant.slug[variant];
}

export async function getExperimentVariantPaths(pages): Promise<VariantPath[]> {
  const phExperiments = await api.getExperiments();
  let variantPaths = [];

  for (const phExperiment of phExperiments) {
    const experiment = experiments.find(
      experiment => experiment.id === phExperiment.feature_flag_key,
    );

    if (experiment) {
      const { feature_flag_variants } = phExperiment.parameters;
      const page = pages.find(page => page.slug === experiment.slug);
      const { language, parent, slug } = page;

      variantPaths = feature_flag_variants.map(({ key }: { key: string }) => {
        return {
          params: {
            slug: [...(parent?.node ? [parent?.node?.slug] : []), slug, key], // e.g. ['medical-card', 'california', 'test']
            locale: language?.slug,
          },
        };
      });
    }
  }

  return variantPaths;
}

/**
 * Fetch wrapper for the Posthog API
 */
export async function posthog(
  path: string,
  method: string,
  { data }: { data?: any } = {},
): Promise<any> {
  const url = new URL(POSTHOG_API_HOST);
  url.pathname = path;

  if (!POSTHOG_PERSONAL_API_KEY) {
    throw new Error('No Posthog API key was provided');
  }

  const res = await fetch(url.href, {
    method,
    headers: {
      Authorization: `Bearer ${POSTHOG_PERSONAL_API_KEY}`,
    },
    body: JSON.stringify(data),
  });

  const resData = await res.json();

  if (res.ok) {
    return resData;
  } else {
    throw new Error(
      `Posthog failed with (${res.status}): ${
        typeof resData === 'string' ? resData : JSON.stringify(resData, null, 2)
      }`,
    );
  }
}

const api = {
  // https://posthog.com/docs/api/experiments#get-api-projects-project_id-experiments
  async getExperiments() {
    const experiments = await posthog(
      `/api/projects/${POSTHOG_PROJECT_ID}/experiments`,
      'GET',
    );

    if (!experiments.results.length) {
      return null;
    }

    return experiments.results.map(result => result);
  },
  // https://posthog.com/docs/api/experiments#get-api-projects-project_id-experiments
  async getExperiment(experimentId: number) {
    const experiment = await posthog(
      `/api/projects/${POSTHOG_PROJECT_ID}/experiments/${experimentId}`,
      'GET',
    );

    if (!experiment) {
      return null;
    }

    return experiment;
  },
  async getFeatureFlags(
    distinctId: string,
    personProperties?: Record<string, any>,
  ) {
    try {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 3000);
      const posthogRes = await fetch(`${POSTHOG_API_HOST}/decide?v=3`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          api_key: POSTHOG_API_KEY,
          distinct_id: distinctId,
          person_properties: personProperties ?? {},
        }),
        signal: controller.signal,
      });

      clearTimeout(timeout);

      if (!posthogRes.ok) {
        const text = await posthogRes.text();
        console.warn(`[PostHog] Non-OK response: ${posthogRes.status} ${text}`);
        return null; // fallback
      }

      const contentType = posthogRes.headers.get('content-type') || '';
      if (!contentType.includes('application/json')) {
        const text = await posthogRes.text();
        console.warn('[PostHog] Invalid JSON response:', text);
        return null;
      }
      const data = await posthogRes.json();
      return data;
    } catch (err: any) {
      console.error(
        '[PostHog] Failed to fetch feature flags:',
        err?.message || err,
      );
      return null;
    }
  },
};

export default api;
